import * as React from 'react';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import DataStore from '../../store/DataStore';
import messages from '../messages';
import classNames from 'classnames';
interface IDataStore {
  dataStore?: DataStore;
}

const Intro: React.SFC<RouteProps & IDataStore> = ({ dataStore }) => {
  return (
    <p className={classNames('c-bubble__content')}>
      <FormattedMessage {...messages.intro} />
    </p>
  );
};

export default inject('dataStore')(Intro);



// WEBPACK FOOTER //
// ./src/containers/fitting/components/Intro.tsx